import type * as React from 'react'

import clsx from 'clsx'

import { ImagePlusIcon, Link, Text } from '@buffer-mono/popcorn'

import styles from './DropZone.module.css'

import type { JSX } from 'react'

interface DropZoneProps {
  isDragging: boolean
  onDragEnter: (event: React.DragEvent<HTMLDivElement>) => void
  onDragOver: (event: React.DragEvent<HTMLDivElement>) => void
  onDragLeave: (event: React.DragEvent<HTMLDivElement>) => void
  onDrop: (event: React.DragEvent<HTMLDivElement>) => void
  onAttachClick: () => void
}

export function DropZone({
  isDragging,
  onDragEnter,
  onDragOver,
  onDragLeave,
  onDrop,
  onAttachClick,
}: DropZoneProps): JSX.Element {
  return (
    <div
      className={clsx(styles.dropZone, isDragging && styles.dropZoneDragging)}
      onDragEnter={onDragEnter}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      onClick={onAttachClick}
      // oxlint-disable-next-line jsx-a11y/prefer-tag-over-role -- The drop zone is a labelled keyboard-operable drag-and-drop button.
      role="button"
      tabIndex={0}
      onKeyDown={(e): void => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onAttachClick()
        }
      }}
      aria-label="Drop files here or click to select"
    >
      <ImagePlusIcon className={styles.icon} />
      <Text size="sm" color="subtle">
        {isDragging ? (
          'Drop files here'
        ) : (
          <>
            Drag & drop or <Link as="span">upload a file</Link>
          </>
        )}
      </Text>
    </div>
  )
}
